import { createTheme } from "@mui/material/styles";

export default function theme() {
  return createTheme({
    palette: {
      text: {
        primary: "#ffffff",
        secondary: "rgb(255 255 255 / 60%)",
      },
    },
    typography: {
      fontFamily: "'Gilroy', -apple-system,'sans-serif'",
    },
  });
}
